import { StoreThunk } from "@green24/npm-preact-utils/store";
import { settingsActions } from "../actions/actions";
import { settingsServices } from "../../services/utils-services";

export class Thunk_Settings extends StoreThunk {
	get(locationID) {
		this.dispatch(settingsActions.getFetchPending());

		return new Promise((resolve, reject) => {
			settingsServices.getItem(locationID).then(settings => {
				this.dispatch(settingsActions.getFetchFulfilled(settings));
				resolve(settings);
			}, (res) => {
				this.dispatch(settingsActions.getFetchRejected(res));
				reject(res);
			});
		})
	}
}
